var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"save-state-indicator-container",class:{ unsaved: !_vm.saved, saved: _vm.saved }},[(_vm.saved)?_c('span',[_vm._v("保存済")]):_c('span',[_vm._v("未保存")])])}
var staticRenderFns = []

export { render, staticRenderFns }